import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";

export default function PaiementStripeForm() {

	let { prestationKey, produitKey } = useParams();

	const stripe = useStripe();
	const elements = useElements();

	const [message, setMessage] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {

		if (!stripe) {
			return;
		}

		const clientSecret = new URLSearchParams(window.location.search).get(
			"payment_intent_client_secret"
		);

		if (!clientSecret) {
			return;
		}

		stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
			switch (paymentIntent.status) {
				case "succeeded":
					setMessage("Paiement effectué avec succés !");
					break;
				case "processing":
					setMessage("Paiement en cours.");
					break;
				case "requires_payment_method":
					setMessage("Paiement en échec, veuillez procéder à un nouvel essai.");
					break;
				default:
					setMessage("Une erreur s'est produite'.");
					break;
			}
		});
	}, [stripe]);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			return;
		}

		setIsLoading(true);

		const { error } = await stripe.confirmPayment({
			elements,
			confirmParams: {
				// Make sure to change this to your payment completion page
				return_url: window.location.origin + process.env.REACT_APP_CATALOGUE_URL + '/' + prestationKey + '/' + produitKey + '/commande-confirmation/',
			},
		});

		// This point will only be reached if there is an immediate error when
		// confirming the payment. Otherwise, your customer will be redirected to
		// your `return_url`. For some payment methods like iDEAL, your customer will
		// be redirected to an intermediate site first to authorize the payment, then
		// redirected to the `return_url`.
		if (error.type === "card_error" || error.type === "validation_error") {
			setMessage(error.message);
		} else {
			setMessage("Une erreur imprévue s'est produite.'");
		}

		setIsLoading(false);
	};

	return (
		<form id="payment-form" onSubmit={handleSubmit}>
			<PaymentElement id="payment-element" />
			<button disabled={isLoading || !stripe || !elements} id="submit" className="stripe-button">
				<span id="button-text">
					{isLoading ? <div className="spinner" id="spinner"></div> : "Procéder au paiement"}
				</span>
			</button>
			{/* Show any error or success messages */}
			{message && <div id="payment-message">{message}</div>}
		</form>
	);
}